var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.57031 21.6836C1.57031 24.2768 1.57031 25.5721 2.37606 26.3778C3.18181 27.1836 4.47706 27.1836 7.07031 27.1836H22.1953C24.7886 27.1836 26.0838 27.1836 26.8896 26.3778C27.6953 25.5721 27.6953 24.2768 27.6953 21.6836",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8828 24.4336H17.3828M20.8203 5.18359V9.30859M18.7578 5.18359H22.8828C23.5236 5.18359 23.8439 5.18359 24.0969 5.07909C24.4332 4.93924 24.7002 4.67172 24.8394 4.33522C24.9453 4.08222 24.9453 3.76184 24.9453 3.12109C24.9453 2.48034 24.9453 2.15997 24.8408 1.90697C24.701 1.57073 24.4334 1.3037 24.0969 1.16447C23.8439 1.05859 23.5236 1.05859 22.8828 1.05859H18.7578C18.1171 1.05859 17.7967 1.05859 17.5437 1.16309C17.2074 1.30294 16.9404 1.57047 16.8012 1.90697C16.6953 2.15997 16.6953 2.48034 16.6953 3.12109C16.6953 3.76184 16.6953 4.08222 16.7998 4.33522C16.9397 4.67146 17.2072 4.93849 17.5437 5.07772C17.7967 5.18359 18.1171 5.18359 18.7578 5.18359Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6953 21.6836H1.57031L3.36331 13.6151C3.82256 11.5512 4.05081 10.5186 4.80569 9.91359C5.56056 9.30859 6.61656 9.30859 8.73269 9.30859H20.5329C22.6491 9.30859 23.7064 9.30859 24.4599 9.91359C25.2148 10.5186 25.4431 11.5498 25.9037 13.6151L27.6953 21.6836Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44531 13.4336H9.13281M14.2891 13.4336H14.9766M20.1328 13.4336H20.8203M8.44531 17.5586H9.13281M14.2891 17.5586H14.9766M20.1328 17.5586H20.8203",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionMachine);
export default __webpack_public_path__ + "static/media/subscriptionMachine.3d9172a836509a4062faed094086dfa1.svg";
export { ForwardRef as ReactComponent };